
import axios from 'axios';
import Cookie from '@/utils/cookie';
import { production } from '../config';

// create an axios instance
const http = axios.create({
    baseURL: 'https://api.agent61.com/awclient',
    // baseURL: 'http://test-api.agent61.com/awclient',
    // baseURL: 'http://192.168.70.129:18201/awclient',
    // baseURL: 'http://127.0.0.1:18201/awclient',
    timeout: 30000, // request timeout
    responseType: "json",
    withCredentials: true,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      // "Host": "api.tcvg.pw",
      // "Origin": "api.tcvg.pw",
    }
  });

http.interceptors.request.use(config => {
    let token = Cookie.getCookie('token');
    if (token) {
        config.headers['token'] = token;
    }
    if (!production) {
      config.url = config.url.replace('', '');
    }
    return config;
});

export default http;
